export default function ({ ...props }) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
            <path
                d="M6.4999 1.40039C7.77004 1.40039 8.92003 1.91533 9.75249 2.7478C10.585 3.58026 11.0999 4.73026 11.0999 6.00039C11.0999 7.27052 10.585 8.42052 9.75249 9.25298C8.92003 10.0854 7.77004 10.6004 6.4999 10.6004C5.22977 10.6004 4.07977 10.0854 3.24731 9.25298C2.41485 8.42052 1.8999 7.27052 1.8999 6.00039C1.8999 4.73026 2.41485 3.58026 3.24731 2.7478C4.07977 1.91533 5.22977 1.40039 6.4999 1.40039Z"
                stroke="#010101"
            />
            <path
                d="M5.85718 3.64286C5.85718 3.9979 6.14499 4.28571 6.50003 4.28571C6.85508 4.28571 7.14289 3.9979 7.14289 3.64286C7.14289 3.28782 6.85508 3 6.50003 3C6.14499 3 5.85718 3.28782 5.85718 3.64286Z"
                fill="#010101"
            />
            <path
                d="M7 5.5C7 5.22386 6.77614 5 6.5 5C6.22386 5 6 5.22386 6 5.5V8C6 8.27614 6.22386 8.5 6.5 8.5C6.77614 8.5 7 8.27614 7 8V5.5Z"
                fill="#010101"
            />
        </svg>
    );
}
